export const environment = {
  production: false,
  apiRoot: 'https://be-test-ubie.app.ubiecloud.com/jwtapi',
  server: 'https://be-test-ubie.app.ubiecloud.com',
  logRoot: 'http://localhost:1337/api',
  ubieAppUrl: 'http://www.qbuscontrol.local/jwtapi',
  luqasWizardVersion: '1.1.12',
  betaWizardHosts: {
    LQSBOX: 'lqsboxwizard_beta.qbuscontrol.com',
    LQS: 'luqaswizard_beta.qbuscontrol.com',
    EMH: 'emhwizard_beta.qbuscontrol.com',
  },
  wizardHosts: {
    LQSBOX: 'lqsboxwizard.be-test-ubie.app.ubiecloud.com',
    LQS: 'semsawizard.be-test-ubie.app.ubiecloud.com',
    EMH: 'emhwizard.be-test-ubie.app.ubiecloud.com',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
